import { render } from "./CustomerMenuMobile.vue?vue&type=template&id=7b46bf0e&scoped=true"
import script from "./CustomerMenuMobile.vue?vue&type=script&lang=js"
export * from "./CustomerMenuMobile.vue?vue&type=script&lang=js"

import "./CustomerMenuMobile.vue?vue&type=style&index=0&id=7b46bf0e&scoped=true&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b46bf0e"]])

export default __exports__